export enum ZoomChangeSource {
  Step,
  Reset,
}
